<template>
  <button class="home-banner" @click="click">
    <img :src="showcase.cover_web" class="w-100" />
  </button>
</template>

<script>
export default {
  props: {
    showcase: Object
  },
  computed: {
    to() {
      const name = {
        class: "lesson",
        lives_recorded: "live",
        live: "lives"
      }[this.showcase.type];

      return {
        name,
        params: {
          id: this.showcase.content_id
        }
      };
    }
  },
  methods: {
    click() {
      if (this.showcase.type === "external_link") {
        window.open(this.showcase.link);
      } else {
        this.$router.push(this.to);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-banner {
  display: block;
  background: none;
  border: none;
  padding: 0;
}
</style>
